import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import "typeface-roboto";

import Beschikbaarheid from "./Beschikbaarheid";
//import Auto from "./Auto";

const styles = theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(25),
    flexBasis: "33.33%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.text.secondary
  },
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  textFieldlong: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 600
  },
  formlabel: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
    color: "yellow"
  },
  menu: {
    width: 200
  },
  bootstrapInput: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "4px 4px",
    width: "calc(100% - 24px)",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: [
      "Roboto",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    "&:focus": {
      borderColor: "gold",
      //"#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      backgroundColor: "gold"
    }
  },
  ahdFormLabel: {
    fontFamily: [
      "Roboto",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',

      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ],
    fontSize: 12,
    color: "green"
  },
  ahdFormLabelGeslacht: {
    fontFamily: [
      "Roboto",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',

      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ],
    fontSize: 10,
    color: "green",
    fontWeight: "700"
  },
  ahdInput: {
    fontFamily: [
      "Roboto",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',

      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ],
    fontSize: 16,
    color: "blue",
    fontWeight: "400"
  },
  ahdRoot: {
    fontSize: 18,
    color: "blue"
  }
});

class VrijwilligerForm extends React.Component {
  state = {
    disabled: true
  };

  handleChange = name => event => {
    //this.setState(prevState => ({ score: prevState.score + 1 }));
    // this.setState(prevState => ({
    //   changes: { [name]: event.target.value }
    // }));
    //Dit bewaard in ieder geval 1 veld
    //this.setState({ changes: { [name]: event.target.value } });
    const { gebruikersNaam } = this.props;
    let gebsort = "";
    if (name === "geboortedatum") {
      gebsort = event.target.value.substring(5).replace("-", "");
    }
    this.setState({
      [name]: event.target.value,
      gebsort: gebsort,
      zz_lastupdate:
        new Date().toLocaleDateString("nl-NL") +
        " " +
        new Date().toLocaleTimeString("nl-NL"),
      zz_gebruikersNaam: gebruikersNaam
    });
    //console.log(this.state);
  };

  saveWijzigingen = () => {
    //console.log(this.state);
    const { vrijwilliger } = this.props;

    this.setState();
    vrijwilliger.update(this.state);
  };
  // handleChange = name => event => {
  //   const { vrijwilliger, gebruikersNaam } = this.props;
  //   vrijwilliger.update({
  //     [name]: event.target.value,
  //     zz_lastupdate:
  //       new Date().toLocaleDateString("nl-NL") +
  //       " " +
  //       new Date().toLocaleTimeString("nl-NL"),
  //     zz_gebruikersNaam: gebruikersNaam
  //   });
  // };

  handleChangeCheckBox = name => event => {
    const { gebruikersNaam } = this.props;

    this.setState({
      [name]: !this.state[name],
      zz_lastupdate:
        new Date().toLocaleDateString("nl-NL") +
        " " +
        new Date().toLocaleTimeString("nl-NL"),
      zz_gebruikersNaam: gebruikersNaam
    });
  };
  // handleChangeCheckBox = name => event => {
  //   const { vrijwilliger, gebruikersNaam, gebruikersrollen } = this.props;

  //   if (vrijwilliger.data[name]) {
  //     vrijwilliger.update({
  //       [name]: false,
  //       zz_lastupdate:
  //         new Date().toLocaleDateString("nl-NL") +
  //         " " +
  //         new Date().toLocaleTimeString("nl-NL"),
  //       zz_gebruikersNaam: gebruikersNaam
  //     });
  //   } else {
  //     vrijwilliger.update({
  //       [name]: true,
  //       zz_lastupdate:
  //         new Date().toLocaleDateString("nl-NL") +
  //         " " +
  //         new Date().toLocaleTimeString("nl-NL"),
  //       zz_gebruikersNaam: gebruikersNaam
  //     });
  //   }
  // };
  handlePanelChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  componentDidMount() {
    const editable =
      this.props.gebruikersrollen.search("admin") > -1 ||
      this.props.gebruikersrollen.search("kantoor") > -1;
    this.setState({
      disabled: !editable
    });
    if (this.props.vrijwilliger) {
      this.setState({
        expanded: null,
        geslacht: this.props.vrijwilliger.data.geslacht || "",
        Bestuur: this.props.vrijwilliger.data.Bestuur || false,
        KlussenInstellingen:
          this.props.vrijwilliger.data.KlussenInstellingen || false,
        Kantoor: this.props.vrijwilliger.data.Kantoor || false,
        Chauffeur: this.props.vrijwilliger.data.Chauffeur || false,
        ChauffeurInstellingen:
          this.props.vrijwilliger.data.ChauffeurInstellingen || false,
        Boodschap: this.props.vrijwilliger.data.Boodschap || false,
        Electra: this.props.vrijwilliger.data.Electra || false,
        Techniek: this.props.vrijwilliger.data.Techniek || false,
        Timmeren: this.props.vrijwilliger.data.Timmeren || false,
        Wandelen: this.props.vrijwilliger.data.Wandelen || false,
        Tuin: this.props.vrijwilliger.data.Tuin || false,
        Telefoondienst: this.props.vrijwilliger.data.Telefoondienst || false,
        Lief_en_leed: this.props.vrijwilliger.data.Lief_en_leed || false,
        PR: this.props.vrijwilliger.data.PR || false,
        Algemeneklusjes: this.props.vrijwilliger.data.Algemeneklusjes || false,
        trekhaak: this.props.vrijwilliger.data.trekhaak || false,
        stationwagen: this.props.vrijwilliger.data.stationwagen || false,
        auto: this.props.vrijwilliger.data.auto || false,
        rollator: this.props.vrijwilliger.data.rollator || false,
        verzekeringsvorm:
          this.props.vrijwilliger.data.verzekeringsvorm || false,
        hogeauto: this.props.vrijwilliger.data.hogeauto || false,
        laatsteklus: this.props.vrijwilliger.data.laatsteklus || Date.now()
      });
    }
  }

  render() {
    const {
      classes,
      vrijwilliger,
      gebruikersNaam,
      gebruikersrollen
    } = this.props;

    // ---

    const {
      voornaam,
      tussenvoegsel,
      achternaam,
      adres,
      postcode,
      woonplaats,
      vogdatum,
      datum_in_dienst,
      telefoon,
      email,
      backuptelefoon,
      opmerkingbestuur,
      ervaringmetklant,
      geboortedatum,
      initialen,
      displayNaam,
      rollen,
      aantalpersonen,
      kenteken,
      beschikbaarheidsInfo
    } = vrijwilliger.data;

    return (
      <form className={classes.container} autoComplete="off">
        <div style={{ width: "100%" }}>
          <TextField
            required
            disabled={this.state.disabled}
            id="voornaam"
            label="Voornaam"
            className={classes.textField}
            defaultValue={voornaam || ""}
            onChange={this.handleChange("voornaam")}
            margin="normal"
            // InputProps={{
            //   disableUnderline: true,
            //   classes: {
            //     root: classes.bootstrapRoot,
            //     input: classes.bootstrapInput
            //   }
            // }}
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            disabled={this.state.disabled}
            id="tussenvoegsel"
            label="Tussenvoegsel"
            defaultValue={tussenvoegsel || ""}
            className={classes.textField}
            onChange={this.handleChange("tussenvoegsel")}
            margin="normal"
            // InputLabelProps={{
            //   shrink: true,
            //   className: classes.bootstrapFormLabel
            // }}
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            required
            disabled={this.state.disabled}
            id="achternaam"
            label="Achternaam"
            defaultValue={achternaam || ""}
            onChange={this.handleChange("achternaam")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            required
            disabled={this.state.disabled}
            id="adres"
            label="Adres"
            defaultValue={adres || ""}
            onChange={this.handleChange("adres")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            required
            disabled={this.state.disabled}
            id="postcode"
            label="Postcode"
            defaultValue={postcode || ""}
            onChange={this.handleChange("postcode")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            required
            disabled={this.state.disabled}
            id="woonplaats"
            label="Woonplaats"
            defaultValue={woonplaats || ""}
            onChange={this.handleChange("woonplaats")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
        </div>
        <div style={{ width: "100%", height: "10px" }} />
        {/* // Diverse kenmerken */}
        <TextField
          required
          disabled={this.state.disabled}
          id="telefoonnummer"
          label="Hoofdtelefoonnummer"
          defaultValue={telefoon || ""}
          onChange={this.handleChange("telefoon")}
          className={classes.textField}
          margin="normal"
          InputProps={{
            classes: {
              root: classes.ahdRoot,
              input: classes.ahdInput
            }
          }}
          InputLabelProps={{
            shrink: true,
            className: classes.ahdFormLabel
          }}
        />
        <TextField
          disabled={this.state.disabled}
          id="backup_telefoonnummer"
          label="Backup Telefoonnummer"
          defaultValue={backuptelefoon || ""}
          onChange={this.handleChange("backuptelefoon")}
          className={classes.textField}
          margin="normal"
          InputProps={{
            classes: {
              root: classes.ahdRoot,
              input: classes.ahdInput
            }
          }}
          InputLabelProps={{
            //shrink: true,
            className: classes.ahdFormLabel
          }}
        />
        <TextField
          disabled={this.state.disabled}
          id="email"
          label="Email-adres"
          defaultValue={email || ""}
          onChange={this.handleChange("email")}
          className={classes.textField}
          margin="normal"
          InputProps={{
            classes: {
              root: classes.ahdRoot,
              input: classes.ahdInput
            }
          }}
          InputLabelProps={{
            //shrink: true,
            className: classes.ahdFormLabel
          }}
        />
        <TextField
          disabled={this.state.disabled}
          id="datum_in_dienst"
          label="Datum in diensttreding"
          type="date"
          defaultValue={datum_in_dienst || "2018-01-01"}
          className={classes.textField}
          style={{ marginTop: "18px" }}
          onChange={this.handleChange("datum_in_dienst")}
          InputProps={{
            classes: {
              root: classes.ahdRoot,
              input: classes.ahdInput
            }
          }}
          InputLabelProps={{
            //shrink: true,
            className: classes.ahdFormLabel
          }}
        />
        <FormControl
          disabled={this.state.disabled}
          className={classes.ahdformlabel}
          style={{ marginTop: "20px" }}
        >
          <FormLabel
            //component="legend"
            className={classes.ahdFormLabelGeslacht}
          >
            Geslacht
          </FormLabel>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.geslacht === "Man"}
                  onChange={this.handleChange("geslacht")}
                  value="Man"
                  color="primary"
                />
              }
              label="Man"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.geslacht === "Vrouw"}
                  onChange={this.handleChange("geslacht")}
                  value="Vrouw"
                />
              }
              label="Vrouw"
            />
          </FormGroup>
        </FormControl>
        {/* //VOG en opmerking bestuur aan het einde */}
        {/* <FormControl component="fieldset"> */}
        <TextField
          disabled={this.state.disabled}
          id="datum_vog"
          label="Datum VOG"
          type="date"
          defaultValue={vogdatum || "2018-01-01"}
          className={classes.textField}
          style={{ marginTop: "18px" }}
          onChange={this.handleChange("vogdatum")}
          InputProps={{
            classes: {
              root: classes.ahdRoot,
              input: classes.ahdInput
            }
          }}
          InputLabelProps={{
            //shrink: true,
            className: classes.ahdFormLabel
          }}
        />
        <TextField
          disabled={this.state.disabled}
          id="geboortedatum"
          label="Geboortedatum"
          type="date"
          defaultValue={geboortedatum || "1963-01-01"}
          className={classes.textField}
          style={{ marginTop: "18px" }}
          onChange={this.handleChange("geboortedatum")}
          InputProps={{
            classes: {
              root: classes.ahdRoot,
              input: classes.ahdInput
            }
          }}
          InputLabelProps={{
            //shrink: true,
            className: classes.ahdFormLabel
          }}
        />

        <TextField
          disabled={this.state.disabled}
          id="initialen"
          label="Initialen"
          defaultValue={initialen || ""}
          onChange={this.handleChange("initialen")}
          className={classes.textField}
          margin="normal"
          InputProps={{
            classes: {
              root: classes.ahdRoot,
              input: classes.ahdInput
            }
          }}
          InputLabelProps={{
            //shrink: true,
            className: classes.ahdFormLabel
          }}
        />
        {this.props.gebruikersrollen.search("bestuur") > -1 && (
          <TextField
            // disabled={this.state.disabled}
            id="opmerkingbestuur"
            label="Opmerking bestuur"
            multiline
            rowsMax="20"
            defaultValue={opmerkingbestuur || ""}
            onChange={this.handleChange("opmerkingbestuur")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              //shrink: true,
              className: classes.ahdFormLabel
            }}
          />
        )}
        <TextField
          disabled={this.state.disabled}
          id="ervaringmetklant"
          label="Ervaring met klant / Opmerkingen"
          multiline
          rowsMax="20"
          defaultValue={ervaringmetklant || ""}
          onChange={this.handleChange("ervaringmetklant")}
          className={classes.textField}
          margin="normal"
          InputProps={{
            classes: {
              root: classes.ahdRoot,
              input: classes.ahdInput
            }
          }}
          InputLabelProps={{
            //shrink: true,
            className: classes.ahdFormLabel
          }}
        />
        {this.props.gebruikersrollen.search("editrollen") > -1 && (
          <TextField
            // disabled={this.state.disabled}
            id="displayNaam"
            label="displayNaam"
            rowsMax="1"
            defaultValue={displayNaam || ""}
            onChange={this.handleChange("displayNaam")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              //shrink: true,
              className: classes.ahdFormLabel
            }}
          />
        )}
        {this.props.gebruikersrollen.search("editrollen") > -1 && (
          <TextField
            // disabled={this.state.disabled}
            id="rollen"
            label="rollen"
            rowsMax="1"
            defaultValue={rollen || ""}
            onChange={this.handleChange("rollen")}
            placeholder="kantoor,admin,bestuur,editvrijwilligers,editklanten,editrollen"
            className={classes.textFieldlong}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              //shrink: true,
              className: classes.ahdFormLabel
            }}
          />
        )}
        <div style={{ width: "100%", marginTop: "20px", color: "blue" }}>
          Beschikbaar voor:
        </div>
        <Divider light />
        <div style={{ width: "100%" }}>
          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.Bestuur === true}
                onChange={this.handleChangeCheckBox("Bestuur")}
                value="Bestuur"
                color="primary"
              />
            }
            label="Bestuur"
          />
          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.Kantoor === true}
                onChange={this.handleChangeCheckBox("Kantoor")}
                value="Kantoor"
                color="primary"
              />
            }
            label="Kantoor"
          />
          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.Chauffeur === true}
                onChange={this.handleChangeCheckBox("Chauffeur")}
                value="Chauffeur"
                color="primary"
              />
            }
            label="Chauffeur"
          />
          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.ChauffeurInstellingen === true}
                onChange={this.handleChangeCheckBox("ChauffeurInstellingen")}
                value="Chauffeurinstellingen"
                color="primary"
              />
            }
            label="Chauffeur Instellingen"
            style={{ fontSize: "12px" }}
          />
          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.Boodschap === true}
                onChange={this.handleChangeCheckBox("Boodschap")}
                value="Boodschap"
                color="primary"
              />
            }
            label="Boodschap"
          />
          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.Electra === true}
                onChange={this.handleChangeCheckBox("Electra")}
                value="Electra"
                color="primary"
              />
            }
            label="Electra"
          />
          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.Techniek === true}
                onChange={this.handleChangeCheckBox("Techniek")}
                value="Techniek"
                color="primary"
              />
            }
            label="Techniek"
          />
          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.Timmeren === true}
                onChange={this.handleChangeCheckBox("Timmeren")}
                value="Timmeren"
                color="primary"
              />
            }
            label="Timmeren"
            // classes={{ root: classes.ahdRoot }}
          />

          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.Wandelen === true}
                onChange={this.handleChangeCheckBox("Wandelen")}
                value="Wandelen"
                color="primary"
              />
            }
            label="Wandelen"
          />

          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.Tuin === true}
                onChange={this.handleChangeCheckBox("Tuin")}
                value="Tuin"
                color="primary"
              />
            }
            label="Tuin"
          />
          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.Telefoondienst === true}
                onChange={this.handleChangeCheckBox("Telefoondienst")}
                value="Telefoondienst"
                color="primary"
              />
            }
            label="Telefoondienst"
          />

          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.Lief_en_leed === true}
                onChange={this.handleChangeCheckBox("Lief_en_leed")}
                value="Lief_en_leed"
                color="primary"
              />
            }
            label="Lief en leed"
          />
          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.PR === true}
                onChange={this.handleChangeCheckBox("PR")}
                value="PR"
                color="primary"
              />
            }
            label="PR"
          />
          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.Algemeneklusjes === true}
                onChange={this.handleChangeCheckBox("Algemeneklusjes")}
                value="Algemeneklusjes"
                color="primary"
              />
            }
            label="Algemene klusjes"
          />
          <FormControlLabel
            disabled={this.state.disabled}
            control={
              <Checkbox
                checked={this.state.KlussenInstellingen === true}
                onChange={this.handleChangeCheckBox("KlussenInstellingen")}
                value="AlgemeneKKlussenInstellingenlusjes"
                color="primary"
              />
            }
            label="Klussen Instellingen"
          />
        </div>
        <div style={{ width: "100%", marginTop: "20px", color: "blue" }}>
          Beschikbaarheid:
        </div>
        <div style={{ width: "100%" }}>
          <Beschikbaarheid
            vrijwilliger={vrijwilliger}
            gebruikersNaam={gebruikersNaam}
            classes={classes}
            disabled={this.state.disabled}
          />
          <TextField
            disabled={this.state.disabled}
            id="beschikbaarheidsInfo"
            label="Opmerkingen omtrent beschikbaarheid"
            multiline
            rowsMax="20"
            defaultValue={beschikbaarheidsInfo || ""}
            onChange={this.handleChange("beschikbaarheidsInfo")}
            className={classes.textFieldlong}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              //shrink: true,
              className: classes.ahdFormLabel
            }}
          />
        </div>
        <div style={{ width: "100%" }}>
          {/* <Auto
            vrijwilliger={vrijwilliger}
            gebruikersNaam={gebruikersNaam}
            gebruikersrollen={gebruikersrollen}
            classes={classes}
            disabled={this.state.disabled}
          /> */}
        </div>
        <div>
          <hr
            style={{
              border: 2,
              height: "5px",
              width: "100%",
              color: "blue"
            }}
          />
          <div style={{ width: "100%", marginTop: "20px", color: "blue" }}>
            {" "}
            Auto:{" "}
            <FormControlLabel
              disabled={this.state.disabled}
              control={
                <Checkbox
                  checked={this.state.auto === true}
                  onChange={this.handleChangeCheckBox("auto")}
                  value="auto"
                  color="secondary"
                />
              }
              label=""
            />
          </div>
          <ExpansionPanel
            expanded={this.state.expanded === "auto"}
            onChange={this.handlePanelChange("auto")}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" className={classes.heading}>
                Details van de auto
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <div style={{ width: "100%", marginTop: "0px" }}>
                {gebruikersrollen.search("admin") > -1 && (
                  <FormLabel
                    //component="legend"
                    className={classes.ahdFormLabelGeslacht}
                  >
                    Verzekeringsvorm
                  </FormLabel>
                )}
                {gebruikersrollen.search("admin") > -1 && (
                  <FormGroup row>
                    <FormControlLabel
                      disabled={this.state.disabled}
                      control={
                        <Checkbox
                          checked={this.state.verzekeringsvorm === "All-Risk"}
                          onChange={this.handleChange("verzekeringsvorm")}
                          value="All-Risk"
                          color="primary"
                        />
                      }
                      label="All-Risk"
                    />
                    <FormControlLabel
                      disabled={this.state.disabled}
                      control={
                        <Checkbox
                          checked={this.state.verzekeringsvorm === "WA-Casco"}
                          onChange={this.handleChange("verzekeringsvorm")}
                          value="WA-Casco"
                        />
                      }
                      label="WA-Casco"
                    />
                    <FormControlLabel
                      disabled={this.state.disabled}
                      control={
                        <Checkbox
                          checked={this.state.verzekeringsvorm === "WA"}
                          onChange={this.handleChange("verzekeringsvorm")}
                          value="WA"
                        />
                      }
                      label="WA"
                    />
                  </FormGroup>
                )}
                {gebruikersrollen.search("admin") > -1 && (
                  <TextField
                    disabled={this.state.disabled}
                    id="kenteken"
                    label="Kenteken"
                    defaultValue={kenteken || ""}
                    type="text"
                    onChange={this.handleChange("kenteken")}
                    className={classes.TextField}
                    style={{ marginTop: "18px" }}
                    margin="normal"
                    InputProps={{
                      classes: {
                        root: classes.ahdRoot,
                        input: classes.ahdInput
                      }
                    }}
                    InputLabelProps={{
                      //shrink: true,
                      className: classes.ahdFormLabel
                    }}
                  />
                )}
                <FormControlLabel
                  disabled={this.state.disabled}
                  control={
                    <Checkbox
                      checked={this.state.trekhaak === true}
                      onChange={this.handleChangeCheckBox("trekhaak")}
                      value="trekhaak"
                      color="primary"
                    />
                  }
                  label="Trekhaak"
                />
                <FormControlLabel
                  disabled={this.state.disabled}
                  control={
                    <Checkbox
                      checked={this.state.stationwagen === true}
                      onChange={this.handleChangeCheckBox("stationwagen")}
                      value="stationwagen"
                      color="primary"
                    />
                  }
                  label="Stationwagen"
                />
                <FormControlLabel
                  disabled={this.state.disabled}
                  control={
                    <Checkbox
                      checked={this.state.rollator === true}
                      onChange={this.handleChangeCheckBox("rollator")}
                      value="rollator"
                      color="primary"
                    />
                  }
                  label="Kan rollator vervoeren"
                />
                <FormControlLabel
                  disabled={this.state.disabled}
                  control={
                    <Checkbox
                      checked={this.state.hogeauto === true}
                      onChange={this.handleChangeCheckBox("hogeauto")}
                      value="hogeauto"
                      color="primary"
                    />
                  }
                  label="Hoge auto"
                />
                <TextField
                  disabled={this.state.disabled}
                  id="aantalpersonen"
                  label="Aantal personen"
                  defaultValue={aantalpersonen || 1}
                  type="number"
                  onChange={this.handleChange("aantalpersonen")}
                  className={classes.number}
                  style={{ marginTop: "18px" }}
                  margin="normal"
                  InputProps={{
                    classes: {
                      root: classes.ahdRoot,
                      input: classes.ahdInput
                    }
                  }}
                  InputLabelProps={{
                    //shrink: true,
                    className: classes.ahdFormLabel
                  }}
                />
              </div>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>
        {/*<TextField
          id="multiline-static"
          label="Multiline"
          multiline
          rows="4"
          defaultValue="Default Value"
          className={classes.textField}
          margin="normal"
        />
        <TextField
          id="helperText"
          label="Helper text"
          defaultValue="Default Value"
          className={classes.textField}
          helperText="Some important text"
          margin="normal"
        />
        <TextField
          id="with-placeholder"
          label="With placeholder"
          placeholder="Placeholder"
          className={classes.textField}
          margin="normal"
        />
        <TextField
          id="textarea"
          label="With placeholder multiline"
          placeholder="Placeholder"
          multiline
          className={classes.textField}
          margin="normal"
        />
        <TextField
          id="number"
          label="Number"
          value={this.state.age}
          onChange={this.handleChange("age")}
          type="number"
          className={classes.textField}
          InputLabelProps={{
            shrink: true
          }}
          margin="normal"
        />
        <TextField
          id="search"
          label="Search field"
          type="search"
          className={classes.textField}
          margin="normal"
        />
        <TextField
          id="select-currency"
          select
          label="Select"
          className={classes.textField}
          value={this.state.currency}
          onChange={this.handleChange("currency")}
          SelectProps={{
            MenuProps: {
              className: classes.menu
            }
          }}
          helperText="Please select your currency"
          margin="normal"
        >
          {currencies.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          id="select-currency-native"
          select
          label="Native select"
          className={classes.textField}
          value={this.state.currency}
          onChange={this.handleChange("currency")}
          SelectProps={{
            native: true,
            MenuProps: {
              className: classes.menu
            }
          }}
          helperText="Please select your currency"
          margin="normal"
        >
          {currencies.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </TextField>
        <TextField
          id="full-width"
          label="Label"
          InputLabelProps={{
            shrink: true
          }}
          placeholder="Placeholder"
          helperText="Full width!"
          fullWidth
          margin="normal"
        /> */}
        <div>
          <p>&nbsp;</p>
        </div>
        <Paper
          style={{
            marginTop: "50px",
            marginLeft: "200px",
            marginRight: "200px"
          }}
        >
          <ul>
            Het veld opmerking bestuur is alleen zichtbaar en wijzigbaar als je
            de rol bestuurslid hebt.
          </ul>
          <ul>
            De rollen admin en kantoor kunnen het formulier verder bewerken.
            Voor alle andere rollen is dit formulier op dit moment niet
            bewerkbaar.
          </ul>
          <ul>
            Thans in gebruik zijnde rollen zijn: kantoor, admin, bestuur,
            ditvrijwilligers, editklanten, editrollen. Het wijzigen daarvan is
            momenteel alleen toegekend aan inlog Pierre. Veranderen we op een
            later moment.
          </ul>
        </Paper>
        <Button
          variant="contained"
          //color="default"
          style={{
            backgroundColor: "green",
            color: "white",
            paddingLeft: "70%"
          }}
          onClick={this.saveWijzigingen}
        >
          Bewaar wijzigingen - sluit venster
        </Button>
      </form>
    );
  }
}

VrijwilligerForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(VrijwilligerForm);



// WEBPACK FOOTER //
// ./src/components/Vrijwilligers/VrijwilligerForm.jsx